import Box from '@mui/material/Box';
import { FC } from 'react';
import { Orders } from '@hellohair/types';
import { useStyles } from '../../theme/styles.helpers';
import { StatusDotStyles } from './StatusDot.Styles';

const STATE_COLORS: Record<string, string> = {
  [Orders.OrderRequestState.IDLE]: '#4881d7',
  [Orders.OrderRequestState.ALLOWED]: '#38a169',
  [Orders.OrderRequestState.DENIED]: '#df1b41',
};

interface StatusDotProps {
  state: string;
}

export const StatusDot: FC<StatusDotProps> = ({ state }) => {
  const color = STATE_COLORS[state] ?? '#a0aab9';
  const styles = useStyles(StatusDotStyles, { color });
  return <Box sx={styles.dot} />;
};
